import React from 'react'
import { Input, Button } from 'reactstrap'

const MerchantFilter = ({onClickFilterCallback}) => {
    const [keyword, setKeyword] = React.useState('')
    const onKeywordChange = (e) => {
        setKeyword( e.target.value)
    }
    const onClickFilter = (e) => {
        e.preventDefault();
        onClickFilterCallback(keyword)
    }
    return (
        <form className="form form--horizontal">
            <div className="form__form-group row">
                <div className="col-md-6">
                    <div className="">
                        <Input 
                            type="text" 
                            placeholder="Search by ID or name" 
                            value={keyword}
                            onChange={onKeywordChange} 
                        />
                    </div>
                </div>
                <div className="col-md-4 d-flex align-items-center max-height-32px pl-1">
                    <Button className="btn btn-sm" type="submit" onClick={onClickFilter}>Filter</Button>
                </div>
            </div>
        </form>
    )
}

export default MerchantFilter;